// Genera un identificador único para cada entrada del carrito
export const generateCartItemKey = (item, selectedExtras, selectedPrice) => {
  const extrasKey = selectedExtras
    .map((extra) => extra.id + (extra?.quantity ?? ""))
    .sort()
    .join("-");
  return `${item.id}-${extrasKey}-${
    !!selectedPrice ? selectedPrice : "single-price"
  }`;
};

export const updateInternalCart = async (updatedItems = []) => {
  if (updatedItems?.every((entity) => entity?.item?.addedForPickUp)) {
    await localStorage.setItem("@cart", JSON.stringify(updatedItems));
  }
};
